import { Callout, ExternalLink } from "@octopusdeploy/design-system-components";
export const EnableExtendedTagSetsCallout = () => {
    return (<Callout type={"information"} title={`Extended Tag Sets should be enabled to use this feature`}>
            Contact <ExternalLink href={"https://octopus.com/support"}>support</ExternalLink> to enable this feature.
        </Callout>);
};
